import Pages from '../Pages/UnsubscribeByEmailPage';
import UnsubscribeByEmailBanner from '../Shared/Banner/UnsubscribeByEmailBanner';

const UnsubscribeByEmail = () => (
  <>
    <UnsubscribeByEmailBanner />
    <Pages />
  </>
);

export default UnsubscribeByEmail;
